// @flow
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { setTransportationOption } from 'store/reducers/appointment/actions';
import {
  cleanClutchError,
  cleanDayTimeError
} from 'store/reducers/errors/actions';

// Components
import ClutchErrorModal from './ClutchErrorModal';

// Selectors
import {
  errorLoadingClutchSlots,
  errorLoadingDayTime,
  errorClutchLoanerNotAvailable
} from 'store/reducers/errors/selectors';
import { getTransportationOption } from 'store/reducers/appointment/selectors';

const mapStateToProps = state => ({
  errorLoadingClutchSlots: errorLoadingClutchSlots(state),
  errorLoanerNotAvailable: errorClutchLoanerNotAvailable(state),
  requestFailure: errorLoadingDayTime(state),
  transportationOption: getTransportationOption(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    {
      goTo,
      cleanClutchError,
      setTransportationOption,
      cleanDayTimeError
    }
  )
)(ClutchErrorModal);



// WEBPACK FOOTER //
// ./src/components/pages/components/ClutchValet/ClutchError/ClutchErrorContainerModal.js